import React, { useState, useEffect } from 'react';

function withClient(Component) {
  function ClientContainer(props) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
      setIsClient(true);
    }, []);

    return isClient ? <Component {...props} /> : null;
  }

  ClientContainer.displayName = `withClient${Component.displayName}`;

  return ClientContainer;
}

export default withClient;
